import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin, LayoutPlugin, DropdownPlugin, TablePlugin, ModalPlugin, CardPlugin, VBScrollspyPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { VuejsDatatableFactory } from 'vuejs-datatable';
import VueCryptojs from 'vue-cryptojs'
import JsonExcel from "vue-json-excel";
import FileSaver from 'file-saver';
import VueSocialChat from 'vue-social-chat';
import VueMask from 'v-mask';
// import VueMaterial from 'vue-material';
// import 'vue-material/dist/vue-material.min.css'
// import 'vue-material/dist/theme/default.css'
// import 'vue-material-design-icons/styles.css';
// import JQuery from 'jquery'

Vue.config.productionTip = false
Vue.config.keyCodes = {
  "arrow-keys":[37,38,39,40]
};
// Install BootstrapVue
Vue.use(BootstrapVue)
Vue.use(LayoutPlugin)
Vue.use(ModalPlugin)
Vue.use(DropdownPlugin)
Vue.use(TablePlugin)
Vue.use(CardPlugin)
Vue.use(VBScrollspyPlugin)
Vue.use(VuejsDatatableFactory)
Vue.use(VueCryptojs)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueSocialChat)
Vue.use(VueMask);

import '../public/scss/style.scss'


Vue.component("downloadExcel", JsonExcel);
// Vue.component("fileSaver", FileSaver);
// Vue.use(VueMaterial);

let app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

global.vm=app;